import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  progressMarkContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '7px',
    '& > div': {
      marginRight: '10px',
      '&:last-child': {
        marginRight: '0',
      }
    }
  },
  markProgress: {
    flex: 1,
    backgroundColor: '#284D02',
    marginBottom: '8px',
    textAlign: 'center',
    padding: '14px 0',
    position: 'relative',
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.12), 0px 16px 16px rgba(0, 0, 0, 0.24)',
    '& > small': {
      color: '#CCCCCC',
    },
    '& > p': {
      color: 'white',
      margin: 0,
    },
    '& > span': {
      width: 0,
      height: 0,
      borderLeft: '14px solid transparent',
      borderRight: '14px solid transparent',
      borderTop: '14px solid #284D02',
      position: 'absolute',
      bottom: '-14px',
      left: '50%',
      marginLeft: '-14px',
    },
    '&.completed': {
      backgroundColor: '#333333',
      '& > span': {
        borderTop: '14px solid #333333',
      }
   
    },
    '&.notShow': {
      display:'none',   
    },
    [theme.breakpoints.down("md")]: {
      fontSize: '12px',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
    }
  },
  progressContainer: {
    position: 'relative',
    height: '48px',
    oveflow: 'hidden',
    width: '100%',
    backgroundColor: '#A3BB76',
    boxShadow: 'inset 0 0 10px rgba(0, 0, 0, 0.54)',
    marginBottom: theme.sizes.spacing.default,
  },
  progressContent: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '48px',
    backgroundColor: theme.palette.primary.main,
    transition: 'all 1.7s ease',
  }
}));

export default useStyles;
